/**
 * Премахва скрола на body, когато се подаде true и го връща, когато се подаде false
 * @param {Boolean} hidden 
 */
export const toggleBodyOverflow = hidden => {
    document.body.style.overflow = hidden ? 'hidden' : 'initial'
}